<template>
  <div>
    <fieldset class="c-filter__controls" :id="`anchor-${label}`">
      <legend class="c-filter__legend">{{ label }}
        <ToolTip v-if="this.$attrs.infoBoxText !== ''" :ttcontent="this.$attrs.infoBoxText" />
      </legend>
      <div class="c-filter__control" v-for="value in this.$attrs.values" :key="value.id">
        <label class="c-input-control c-filter-foldout__input-control" :for="value.id">
          <input :id="value.id" :value="value.label" type="radio" :checked="isSelected(value.id)"
            @change="onChange(value.id)" class="c-input-control__input u-visually-hidden" />
          <span class="c-input-control__indicator"></span>
          <span class="c-input-control__label">{{ value.label }}</span>
        </label>
      </div>
    </fieldset>
  </div>
</template>

<script>
import ToolTip from '@/components/Filter/ToolTip.vue'

export default {
  name: 'RadioFilter',
  components: { ToolTip },
  props: { selectedValue: Array },
  data() {
    return { currentValue: 0 }
  },
  computed: {
    label() {
      return this.$attrs.label
    },
  },
  methods: {
    isSelected(value) {
      this.currentValue = this.selectedValue[0]
      if (this.currentValue !== 0) return this.currentValue === value

      return this.selectedValue[0] === value
    },
    onChange(value) {
      const prevValue = this.currentValue || this.selectedValue[0]
      this.currentValue = value
      this.$emit('onChanged', { add: this.currentValue, remove: prevValue })
    },
  },
}
</script>
